import { PC_LAYOUT_LENGTH } from "constants/UIConstants";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const LayOutContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  max-height: fit-content;
  margin: auto;
  padding-top: 8rem;

  background-color: rgba(249, 251, 253, 1);
  color: black;
  @media screen and (max-width: ${PC_LAYOUT_LENGTH}) {
    padding: 8rem 20px;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: auto;
    padding: 6rem 20px 0;
    height: 100vh;
  }
`;

export const LandingLayOutContainer = styled.div`
  max-width: 100vw;
  margin: auto;
  padding-top: 8rem;
  min-height: calc(100vh - 55.2rem);
  position: relative;
  @media screen and (max-width: ${PC_LAYOUT_LENGTH}) {
    padding: 0;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: auto;
    padding: 0;
    min-height: calc(100vh - 106rem);
  }
`;
